module.exports = __webpack_public_path__ + "img/mailing.c2ebac09.png";